export const APP_VERSION = "2026.10.19";
export default APP_VERSION;
